import React from 'react';
import { Row, Col } from 'antd';
import Link from 'next/link';
import parseCategoryUrl from 'lib/parseCategoryUrl';
import { Title, Text, Category } from 'components/Card';
import Image from 'components/Image';

interface Props {
    $article: Article;
    companyAsCategory?: Company;
}

const ArticleItem = ({ $article, companyAsCategory = undefined }: Props): React.JSX.Element => (
    <Row gutter={16}>
        <Col span={8}>
            <Link href={`/artykuly/${$article.seoSlug}`}>
                <Image
                    type="index"
                    alt={$article.title}
                    height={153}
                    width={272}
                    src={$article.openingImage}
                    style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                />
            </Link>
        </Col>
        <Col span={16}>
            {$article.category && (
                <Category>
                    {companyAsCategory ? (
                        <Link href={`/katalog-firm/${companyAsCategory.seoSlug}`}>
                            {companyAsCategory.name}
                        </Link>
                    ) : (
                        <Link href={parseCategoryUrl($article.category)}>
                            {$article.category.title}
                        </Link>
                    )}
                </Category>
            )}
            <Title>
                <Link href={`/artykuly/${$article.seoSlug}`}>{$article.title}</Link>
            </Title>
            {$article.teaser && (
                <Text>
                    <Link href={`/artykuly/${$article.seoSlug}`}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: $article.teaser
                            }}
                        />
                    </Link>
                </Text>
            )}
        </Col>
    </Row>
);

export default ArticleItem;
